/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {shallowEqual, useSelector} from 'react-redux'
import {AsideMenuItem} from './AsideMenuItem'
import {RootState} from '../../../../setup'
import {
  CheckAccess,
  CheckModulesAccess,
  IsRootUserOrAdmin,
} from '../../../../app/services/Functional'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'

export function AsideMenuMain() {
  const intl = useIntl()
  const showSubscriptionPage = CheckAccess('plans_management.index')
  const showEnterprisePage = CheckAccess('enterprise_plan.index')
  const showCompanyPage = CheckAccess('inspection_companies.index')
  const showProjectPage = CheckAccess('projects.index')
  const showTemplatePage = CheckAccess('inspection_templates.index')
  const showSitePage = CheckAccess('sites.index')
  const showAssetPage = CheckAccess('assets.index')
  const showMappingAssetPage = CheckAccess('mappings.index')
  const showSubscriptionHistoryPage = CheckAccess('subscription_history.index')
  const {active_inspection_company}: any = useSelector<RootState>(
    (state) => ({
      active_inspection_company: state.auth.active_inspection_company,
    }),
    shallowEqual
  )

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/Dashboard.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      {CheckAccess('team_management.index') && (
        <AsideMenuItem
          to='/team-management'
          icon='/media/icons/duotune/general/Team Management.svg'
          title='Team Management'
          fontIcon='bi-layers'
        />
      )}
      {IsRootUserOrAdmin() && (
        <div className='menu-item'>
          <div className='menu-content pt-4 pb-4'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Admin Controls</span>
          </div>
        </div>
      )}
      {IsRootUserOrAdmin() &&
        active_inspection_company &&
        active_inspection_company.slug === 'decent' && (
          <AsideMenuItemWithSub
            to='/templates'
            icon='/media/icons/duotune/general/Template.svg'
            title='Templates'
            fontIcon='bi-layers'
            subMenus={['/templates', '/category']}
          >
            <AsideMenuItem
              to='/templates'
              icon='/media/icons/duotune/general/manage-templates.svg'
              title='Manage'
              fontIcon='bi-layers'
            />
            <AsideMenuItem
              to='/category'
              icon='/media/icons/duotune/general/gen022.svg'
              title='Categories'
              fontIcon='bi-layers'
            />
          </AsideMenuItemWithSub>
        )}

      {(showSubscriptionPage || showEnterprisePage) && (
        <AsideMenuItemWithSub
          to='/plans'
          icon='/media/icons/duotune/general/Subscriptions.svg'
          title='Subscription'
          fontIcon='bi-layers'
          subMenus={['/plans/plans-management', '/plans/enterprise-plan']}
        >
          <>
            {showSubscriptionPage && (
              <AsideMenuItem
                to='/plans/plans-management'
                icon='/media/icons/duotune/general/plan-management.svg'
                title='Manage Plans'
                fontIcon='bi-layers'
              />
            )}
            {showEnterprisePage && (
              <AsideMenuItem
                to='/plans/enterprise-plan'
                icon='/media/icons/duotune/general/enterprise-request.svg'
                title='Enterprise Requests'
                fontIcon='bi-layers'
              />
            )}
          </>
        </AsideMenuItemWithSub>
      )}
      {IsRootUserOrAdmin() && (
        <AsideMenuItemWithSub
          to='/companies'
          icon='/media/icons/duotune/general/company.svg'
          title='Companies'
          fontIcon='bi-layers'
          subMenus={['/inspection-companies', '/account-anonymization-requests']}
        >
          {showCompanyPage && (
            <AsideMenuItem
              to='/inspection-companies'
              icon='/media/icons/duotune/general/company-listing.svg'
              title='Company Listing'
              fontIcon='bi-layers'
            />
          )}
          {active_inspection_company && active_inspection_company.slug === 'decent' && (
            <AsideMenuItem
              to='/account-anonymization-requests'
              icon='/media/icons/duotune/general/account-anonymization.svg'
              title='Anonymization Requests'
              fontIcon='bi-layers'
            />
          )}
        </AsideMenuItemWithSub>
      )}
      {IsRootUserOrAdmin() && (
        <AsideMenuItemWithSub
          to='/configurations'
          icon='/media/icons/duotune/general/configurations.svg'
          title='Configurations'
          fontIcon='bi-layers'
          subMenus={['/notification-templates', '/groups', '/configurations']}
        >
          {CheckAccess('events.index') && (
            <AsideMenuItem
              to='/notification-templates'
              icon='/media/icons/duotune/general/Notification Template.svg'
              title='Notification Templates'
              fontIcon='bi-layers'
            />
          )}
          <AsideMenuItem
            to='/groups'
            icon='/media/icons/duotune/general/User Groups.svg'
            title='User Groups'
            fontIcon='bi-layers'
          />
          {CheckAccess('configurations.index') && (
            <AsideMenuItem
              to='/configurations'
              icon='/media/icons/duotune/general/platform-settings.svg'
              title='Platform Settings'
              fontIcon='bi-layers'
            />
          )}
        </AsideMenuItemWithSub>
      )}

      {CheckModulesAccess([
        'plans_management.index',
        'enterprise_plan.index',
        'inspection_companies.index',
        'projects.index',
        'sites.index',
        'assets.index',
        'inspection_listing.index',
        'inspection_templates.index',
      ]) && (
        <div className='menu-item'>
          <div className='menu-content pt-4 pb-4'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Modules</span>
          </div>
        </div>
      )}
      {CheckAccess('orders.index') && (
        <AsideMenuItem
          to={`${IsRootUserOrAdmin() ? '/manage-orders' : '/your-credits'}`}
          icon='/media/icons/duotune/general/discount.svg'
          title={`${IsRootUserOrAdmin() ? 'Manage Orders' : 'Decent Credits'}`}
          fontIcon='bi-layers'
        />
      )}
      {CheckAccess('calendar.index') && (
        <AsideMenuItem
          to='/schedule'
          icon='/media/icons/duotune/general/calendar.svg'
          title='Schedule'
          fontIcon='bi-layers'
        />
      )}
      {(showProjectPage ||
        showTemplatePage ||
        showSitePage ||
        showAssetPage ||
        showMappingAssetPage) && (
        <AsideMenuItemWithSub
          to='/projects'
          icon='/media/icons/duotune/general/Project Set-up.svg'
          title='Project Setup'
          fontIcon='bi-layers'
          subMenus={['/projects', '/inspection-templates', '/sites', '/assets', '/asset-binding']}
        >
          {showTemplatePage && (
            <AsideMenuItem
              to='/inspection-templates'
              icon='/media/icons/duotune/general/h&s-activity.svg'
              title='H&S Activities'
              fontIcon='bi-layers'
            />
          )}
          {showProjectPage && (
            <AsideMenuItem
              to='/projects'
              icon='/media/icons/duotune/general/projects.svg'
              title='Projects'
              fontIcon='bi-layers'
            />
          )}
          {showSitePage && (
            <AsideMenuItem
              to='/sites'
              icon='/media/icons/duotune/general/sites.svg'
              title='Sites'
              fontIcon='bi-layers'
            />
          )}
          {showAssetPage && (
            <AsideMenuItem
              to='/assets'
              icon='/media/icons/duotune/general/assets.svg'
              title='Assets'
              fontIcon='bi-layers'
            />
          )}
          {showMappingAssetPage && (
            <AsideMenuItem
              to='/asset-binding'
              icon='/media/icons/duotune/general/assets-mapping.svg'
              title='Asset Mapping'
              fontIcon='bi-layers'
            />
          )}
        </AsideMenuItemWithSub>
      )}
      {CheckAccess('inspection_listing.index') && (
        <AsideMenuItemWithSub
          to='/inspection_listing?inspection_status=complete'
          icon='/media/icons/duotune/general/Reports.svg'
          title='Reports'
          fontIcon='bi-layers'
          subMenus={['/inspection-listing']}
        >
          <AsideMenuItem
            to='/inspection-listing?inspection_status=complete'
            icon='/media/icons/duotune/general/h&s-activity.svg'
            title='H&S Activity Reports'
            fontIcon='bi-layers'
          />
        </AsideMenuItemWithSub>
      )}
      {showSubscriptionHistoryPage && (
        <AsideMenuItemWithSub
          to='/subscriptions'
          icon='/media/icons/duotune/general/purchase.svg'
          title='Subscription History'
          fontIcon='bi-layers'
          subMenus={['/subscriptions', '/transaction-history']}
        >
          <AsideMenuItem
            to='/subscriptions'
            icon='/media/icons/duotune/general/subscription-list.svg'
            title='My Subscription'
            fontIcon='bi-layers'
          />
          <AsideMenuItem
            to='/transaction-history'
            icon='/media/icons/duotune/general/transaction-history.svg'
            title='Transaction History'
            fontIcon='bi-layers'
          />
        </AsideMenuItemWithSub>
      )}
    </>
  )
}
